module.exports = __webpack_public_path__ + "static/media/activity-trash.c368c07e.svg";